// extracted by mini-css-extract-plugin
export var container = "checklist-module--container--87cc8";
export var item = "checklist-module--item--32d35";